import React from "react";
import PropTypes from "prop-types";
import { CustomLink } from "../custom-link";
import { getAuthorTemplate } from "../author/get-author-template";
import get from "lodash/get";

function getStoryTypeKey(story = "") {
  switch (story) {
    case "":
      return "";
    case "default":
      return "";
    case "hero-wide":
      return "";
    default:
      return `${story}-`;
  }
}

// Author component can accept these params.
// isLink : Basically changes the component clickable in any scenario.
// author : An author object which will have name, id, date & image.
// authors: An array of authors which will come from story API itself. If the authors array is present we'll ignore the author object.
// showDateOnly: Will hide the `Posted` string infront of every date.
// date   : pass the date value from story object
function Author(props) {
  // If there's only one author.
  const storyTypeKey = getStoryTypeKey(props.story);

  const mountAt = get(props, ["config", "mountAt"]) || "";
  if ((props.author && !props.authors) || (props.authors && props.authors.length === 1)) {
    const author = props.authors ? props.authors[0] : props.author;
    return props.isLink ? (
      <CustomLink href={`${mountAt}/author/` + author.slug}>
        {React.createElement(
          getAuthorTemplate(`${storyTypeKey}single-author`),
          Object.assign({}, { config: props.config, author }, props)
        )}
      </CustomLink>
    ) : (
      React.createElement(
        getAuthorTemplate(`${storyTypeKey}single-author`),
        Object.assign({}, { config: props.config, author }, props)
      )
    );
  }
  // If there're mulitiple authors.
  if (props.authors && props.authors.length !== 1) {
    return React.createElement(getAuthorTemplate(`${storyTypeKey}multi-author`), props);
  }
  // fallback
  return null;
}

Author.propTypes = {
  author: PropTypes.object,
  authors: PropTypes.array,
  isLink: PropTypes.bool,
  config: PropTypes.object,
  story: PropTypes.string
};

export { Author };
